// ==============================|| OVERRIDES - SELECT ||============================== //

export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          // Ensure proper height and text display
          '&.MuiInputBase-input': {
            minHeight: '1.4375em',
            display: 'flex',
            alignItems: 'center'
          },
          // Show placeholder text properly
          '&.MuiSelect-select': {
            '& em': {
              color: theme.vars.palette.grey[500],
              fontStyle: 'normal'
            }
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: '10px 16px',
          '& em': {
            color: theme.vars.palette.grey[500],
            fontStyle: 'normal'
          }
        }
      }
    }
  };
}
